import React, { useState, useEffect } from 'react';
import Applications from '@lms/react-applications';
import FeatureToggler from '../FeatureToggler';
import { getUserRoles } from '../../authentication/authConfig';
import { arrayHasItems } from '../../utils/js';
import { UserType } from '../../enum/UserType';
import { Role } from '../../enum/Role';

const AppSwitcher = () => {
  const [userType, setUserType] = useState();
  const applicationsApiBaseAddress = window?.config?.applicationsApiBaseAddress;

  useEffect(() => {
    let unmounted = false;
    async function init() {
      const userRoles = await getUserRoles();
      if (!unmounted) {
        let tempUserType = null;
        if (arrayHasItems(userRoles)) {
          if (userRoles.indexOf(Role.LMSUser) > -1) {
            tempUserType = UserType.LMS;
          }else if (userRoles.indexOf(Role.LawFirm) > -1) {
            tempUserType = UserType.LawFirm;
          }
        }
        setUserType(tempUserType);
      }
    }
    init();
    return () => {
      unmounted = true;
    };
  }, []);

  if (!userType) return null;

  return (
    <FeatureToggler featureName="AppSwitcherEnabled">
      <Applications
        uri={applicationsApiBaseAddress}
        userType={userType}
      />
    </FeatureToggler>
  );
};

export default AppSwitcher;
